import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { FuturePurchaseStatusFormValue } from "src/models/FuturePurchase.model";

import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";

type Props = {
  formikProps: FormikProps<FuturePurchaseStatusFormValue>;
  onClose: () => void;
};

const StatusForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  const StatusOptions = [
    { label: "Panding", value: "PENDING" },
    { label: "Converted", value: "CONVERTED" },
    { label: "Lost", value: "LOST" },
  ];

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">Status of Future Purchase</div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMSelect
            name="status"
            required
            placeholder="select Status"
            label="Status"
            options={StatusOptions}
            onChange={(newValue: any) => {
              setFieldValue(`status`, newValue);
            }}
            value={values.status}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default StatusForm;
